@if ({ isTop: isTopNav$ | async }; as navigation) {
    <div
        [style.--color-banner-bg]="bgNav || null"
        [ngClass]="{ open: !isCollapsed }"
        [style.--color-nav-border]="bgHeader || null"
        [style.background-color]="bgHeader || null"
        class="navbar-top">
        <div class="container--nav">
            <div class="navbar-top__inner">
                <core-brand-logo category="TOP-NAV"></core-brand-logo>

                <div class="navbar-top__icons" [style.color]="'var(--color-nav-icon, var(--color-text, #000))'">
                    <!-- icons inherit currentColor -->
                    @if (isLoggedIn && displayLoggedInUser) {
                        <p class="navbar-logged-in-name">
                            {{ 'Logged in' | translate }}
                            @if (loggedInUserName) {
                                {{ 'as:' | translate }} <span [innerText]="loggedInUserName"></span>
                            }
                        </p>
                    }
                    @if (searchEnabled) {
                        <core-client-search
                            [style.color]="'var(--color-nav-icon, var(--color-text, #000))'"
                            [style.--color-nav-link-active]="'var(--color-nav-icon, var(--color-text, #000))'"
                            [class.search-icon--is-dark]="bgHeader ? !requiresContrastingTextColor(bgHeader) : null"
                            [class.search-icon--is-light]="bgHeader ? requiresContrastingTextColor(bgHeader) : null"
                            [isSearchButtonIcon]="true"
                            [isDesktop]="isDesktop">
                        </core-client-search>
                    }

                    @if (notificationsEnabled && navigation.isTop) {
                        <core-notifications></core-notifications>
                    }

                    @if (showDarkModeSwitch) {
                        <core-dark-mode-toggle></core-dark-mode-toggle>
                    }

                    <core-client-block-language></core-client-block-language>

                    @if (contactEnabled) {
                        <a
                            [core-analytics]="{ action: 'Get in touch', category: 'TOP-NAV' }"
                            class="btn btn-primary btn--small mb-0 d-none d-nav-block ms-2"
                            routerLink="/contact">
                            {{ 'Get in touch?' | translate }}
                        </a>
                    }
                    @if (customContactButtonEnabled) {
                        <a
                            [core-analytics]="{ action: customContactButtonText, category: 'TOP-NAV' }"
                            [target]="customContactButtonTarget ? '_blank' : '_self'"
                            class="btn btn--small mb-0 d-none d-nav-block ms-2"
                            [ngClass]="[customContactButtonIcon ? 'btn-icon-contact' : '']"
                            [style.background-color]="customContactButtonActionBg || null"
                            [style.color]="customContactButtonActionText || null"
                            [href]="customContactButtonPath"
                            [innerHTML]="customContactButtonText | translate">
                        </a>
                    }

                    @if (portalLink && !isLoggedIn && !isPortalLinkHidden) {
                        <a
                            [attr.target]="portalLinkTarget"
                            [core-analytics]="{ action: 'SIGN IN TO MEMBER AREA', category: 'TOP-NAV' }"
                            [href]="portalLink"
                            [innerText]="'SIGN IN TO MEMBER AREA' | translate"
                            class="btn btn-primary btn--outline btn--small mb-0 d-none d-nav-block ms-2">
                        </a>
                    }

                    @if (isLoggedIn) {
                        <a
                            (click)="logout()"
                            [core-analytics]="{ action: 'Logout', category: 'TOP-NAV' }"
                            class="logout-btn btn btn-dark btn--icon-right btn--small mb-0 d-none d-nav-block"
                            href="javascript:void(0)">
                            {{ 'Logout' | translate }}
                            <span aria-hidden="true" class="material-symbols-outlined">{{ 'Logout' | translate }}</span>
                        </a>
                    }

                    <button
                        (click)="toggleMobileMenu($event)"
                        [attr.aria-expanded]="!isCollapsed"
                        [core-analytics]="{ action: 'Toggle navigation', category: 'TOP-NAV' }"
                        [ngClass]="{
                            open: !isCollapsed,
                            'navbar-toggler--dark': !heroImagesEnabled,
                            'd-none': hideMobileNavigationOnSplashLanding && !isLoggedIn,
                        }"
                        aria-controls="navbarSupportedContent"
                        aria-label="Toggle navigation"
                        class="navbar-toggler"
                        data-bs-target="#navbarSupportedContent"
                        data-bs-toggle="collapse"
                        id="mobile-nav-icon"
                        type="button">
                        <span [style.background-color]="'var(--color-nav-link, var(--color-text, #000))'"></span>
                        <span [style.background-color]="'var(--color-nav-link, var(--color-text, #000))'"></span>
                        <span [style.background-color]="'var(--color-nav-link, var(--color-text, #000))'"></span>
                        <span [style.background-color]="'var(--color-nav-link, var(--color-text, #000))'"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <nav
        [ngClass]="{
            'navbar-with-flyout': isNavbarWithFlyout,
            'd-block d-nav-none': hideNavigationOnSplashLanding && !isLoggedIn,
        }"
        [style.--color-banner-bg]="bgNav || null"
        [style.background-color]="bgNav || null"
        class="navbar navbar-expand-nav"
        role="navigation">
        <div class="container--nav navbar__inner">
            <div
                [style.--color-banner-bg]="bgNav || null"
                [ngClass]="{
                    'navbar-remove-scroll': resetMobileScroll,
                    'is-mobile-nav-footer': showMobileNavFooter(),
                    show: !isCollapsed,
                }"
                [style.background-color]="bgNav || null"
                class="collapse navbar-collapse"
                id="navbarSupportedContent">
                @if (searchEnabled) {
                    <core-client-search
                        (closeTopnavHamburgerNav)="isCollapsed = !isCollapsed"
                        [class.search-icon--is-dark]="bgNav ? !requiresContrastingTextColor(bgNav) : null"
                        [class.search-icon--is-light]="bgNav ? requiresContrastingTextColor(bgNav) : null"
                        [isSearchButtonIcon]="false"
                        class="core-search-form--mobile">
                    </core-client-search>
                }

                <ul class="navbar-nav d-flex w-100">
                    @if (portalLink && !isLoggedIn && !isPortalLinkHidden) {
                        <li class="nav-item">
                            <a
                                [attr.target]="portalLinkTarget"
                                [core-analytics]="{ action: 'SIGN IN TO MEMBER AREA', category: 'TOP-NAV' }"
                                [href]="portalLink"
                                [innerText]="'SIGN IN TO MEMBER AREA' | translate"
                                class="btn btn-primary btn--outline btn--small btn--portal-link-mobile nav-link d-block align-self-start w-auto d-nav-none">
                            </a>
                        </li>
                    }
                    @if (pages$ | async; as _pages) {
                        @for (
                            page of $any(_pages | orderBy: ['displayOrder']);
                            track trackByFn(i, page);
                            let i = $index
                        ) {
                            @if (page.children.length === 0 || page.meta.hideNavDropdown) {
                                @if (showInMenu(page, 'no-child')) {
                                    <li
                                        [ngClass]="{ 'nav-item--posts': isDemoModeAndPostsLink(page) }"
                                        class="nav-item">
                                        <a
                                            (click)="onNavItemClick(i, page, $event)"
                                            [core-analytics]="{ action: page.url, category: 'TOP-NAV' }"
                                            [id]="page.url"
                                            [ngClass]="{
                                                'is-active': setTopNavActiveLinkState(page),
                                                active: setTopNavActiveLinkState(page),
                                            }"
                                            [attr.aria-current]="setTopNavActiveLinkState(page) ? 'page' : 'false'"
                                            class="nav-link"
                                            href="javascript:void(0)">
                                            {{ page.meta.friendlyPageName || page.name }}
                                        </a>
                                    </li>
                                }

                                @if (isDemoMode && page.url === 'articles' && postsEnabled) {
                                    <li class="nav-item">
                                        <a
                                            (click)="navigateToPage([page])"
                                            [core-analytics]="{ action: page.url, category: 'TOP-NAV' }"
                                            [id]="page.url"
                                            [attr.aria-current]="setTopNavActiveLinkState(page) ? 'page' : 'false'"
                                            class="nav-link nav-link--posts-demo"
                                            href="javascript:void(0)">
                                            {{ page.meta.friendlyPageName || page.name }}
                                        </a>
                                    </li>
                                }
                            }

                            @if (page.children.length > 0) {
                                @if (showInMenu(page, 'has-child')) {
                                    <li
                                        (isOpenChange)="onOpenChange($event, i)"
                                        (onShown)="onDropdownOpen()"
                                        [core-analytics]="{ action: 'Toggle ' + page.name, category: 'TOP-NAV' }"
                                        class="nav-item dropdown"
                                        dropdown>
                                        <a
                                            [ngClass]="{ 'is-active': setTopNavActiveLinkState(page) }"
                                            aria-expanded="false"
                                            class="nav-link dropdown-toggle page-dropdown-{{ page.url }}"
                                            dropdownToggle
                                            href="javascript:void(0)"
                                            id="navbarDropdown"
                                            role="button">
                                            {{ page.name }}
                                        </a>

                                        @if (pillars$ | async; as content) {
                                            <div
                                                *dropdownMenu
                                                [core-analytics]="{
                                                    action: 'Toggle ' + page.name,
                                                    category: 'TOP-NAV',
                                                }"
                                                [ngClass]="{
                                                    'dropdown-mobile': !isDesktop,
                                                    'dropdown-flyout':
                                                        menuStyle === 'flyout' ||
                                                        (isIndividualMenuFlyout && menuFlyoutPageId === page.id),
                                                }"
                                                aria-labelledby="navbarDropdown"
                                                class="dropdown-menu"
                                                id="dropdown">
                                                <div [ngClass]="{ 'dropdown-menu__with-posts': postsInNavEnabled }">
                                                    @if (
                                                        isCategoryNav && page.url === 'benefits' && content.length > 0
                                                    ) {
                                                        <div
                                                            class="dropdown-wrapper activeMenuTab-{{
                                                                activeMenuTab.value
                                                            }} benefits w-100">
                                                            <mat-tab-group
                                                                (click)="$event.stopPropagation()"
                                                                (selectedIndexChange)="activeMenuTab.setValue($event)"
                                                                class="nav nav-menu-tabs mx-auto"
                                                                mat-align-tabs="left">
                                                                @for (item of content; track trackByFn($index, item)) {
                                                                    <mat-tab
                                                                        [core-analytics]="{
                                                                            action: item.name,
                                                                            category: 'TOP-NAV',
                                                                        }">
                                                                        <ng-template mat-tab-label>
                                                                            <div
                                                                                [class]="
                                                                                    'pillar-icon pillar-icon--' +
                                                                                    item.pillarClass
                                                                                "></div>
                                                                            <span
                                                                                [innerHTML]="item.name | translate"
                                                                                class="pillar-title"></span>
                                                                        </ng-template>
                                                                        <div
                                                                            class="nav-menu-wrapper w-100 nav-menu-wrapper--{{
                                                                                activeMenuTab.value
                                                                            }}">
                                                                            <div class="row w-100">
                                                                                @for (
                                                                                    categorizedPage of $any(
                                                                                        item.pageCategories
                                                                                            | orderBy: [navigationOrder]
                                                                                    );
                                                                                    track categorizedPage
                                                                                ) {
                                                                                    @if (
                                                                                        showInMenu(
                                                                                            categorizedPage,
                                                                                            'no-child'
                                                                                        )
                                                                                    ) {
                                                                                        <div
                                                                                            class="nav-menu-item col-md-4 col-xl-3">
                                                                                            <a
                                                                                                (click)="
                                                                                                    navigateToPage([
                                                                                                        page,
                                                                                                        categorizedPage,
                                                                                                    ])
                                                                                                "
                                                                                                [attr.aria-label]="
                                                                                                    'Learn more about ' +
                                                                                                    categorizedPage.name
                                                                                                "
                                                                                                [core-analytics]="{
                                                                                                    action: categorizedPage.url,
                                                                                                    category: 'TOP-NAV',
                                                                                                }"
                                                                                                [ngClass]="{
                                                                                                    active: setDropdownActiveLinkState(
                                                                                                        categorizedPage
                                                                                                    ),
                                                                                                }"
                                                                                                class="nav-menu-item__link"
                                                                                                href="javascript:void(0)">
                                                                                                <span
                                                                                                    [innerText]="
                                                                                                        categorizedPage.name
                                                                                                    "
                                                                                                    class="nav-menu-item__name"></span>
                                                                                            </a>
                                                                                        </div>
                                                                                    }
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </mat-tab>
                                                                }
                                                            </mat-tab-group>
                                                            <a
                                                                (click)="navigateToPage([page])"
                                                                [core-analytics]="{
                                                                    action: 'View all benefits',
                                                                    category: 'TOP-NAV',
                                                                }"
                                                                [innerText]="'View all benefits' | translate"
                                                                class="btn btn-primary btn-viewall"
                                                                href="javascript:void(0)">
                                                            </a>
                                                        </div>
                                                    }

                                                    @if (!isCategoryNav || page.url !== 'benefits') {
                                                        @if (page.url !== 'life-journeys') {
                                                            <div
                                                                class="dropdown-wrapper dropdown-wrapper--no-category-nav">
                                                                <div
                                                                    class="nav-menu-wrapper nav-menu-wrapper--{{
                                                                        activeMenuTab.value
                                                                    }} h-auto">
                                                                    <div class="row w-100">
                                                                        @for (
                                                                            child of $any(
                                                                                page.children
                                                                                    | orderBy: [navigationOrder]
                                                                            );
                                                                            track child
                                                                        ) {
                                                                            @if (showInMenu(page, 'no-child')) {
                                                                                <div
                                                                                    class="nav-menu-item col-md-4 col-xl-3">
                                                                                    <a
                                                                                        (click)="
                                                                                            navigateToPage([
                                                                                                page,
                                                                                                child,
                                                                                            ])
                                                                                        "
                                                                                        [attr.aria-label]="
                                                                                            'Learn more about ' +
                                                                                            child.name
                                                                                        "
                                                                                        [core-analytics]="{
                                                                                            action: child.url,
                                                                                            category: 'TOP-NAV',
                                                                                        }"
                                                                                        [ngClass]="{
                                                                                            active: setDropdownActiveLinkState(
                                                                                                child
                                                                                            ),
                                                                                        }"
                                                                                        class="nav-menu-item__link"
                                                                                        href="javascript:void(0)">
                                                                                        <span
                                                                                            [innerText]="child.name"
                                                                                            class="nav-menu-item__name"></span>
                                                                                    </a>
                                                                                </div>
                                                                            }
                                                                        }
                                                                    </div>
                                                                    @if (page.url === 'benefits') {
                                                                        <div class="row w-100 pt-3">
                                                                            <div
                                                                                class="col-12 d-flex justify-content-center align-items-center">
                                                                                <a
                                                                                    (click)="navigateToPage([page])"
                                                                                    [core-analytics]="{
                                                                                        action: 'View all benefits',
                                                                                        category: 'TOP-NAV',
                                                                                    }"
                                                                                    class="btn btn-primary btn-viewall"
                                                                                    href="javascript:void(0)">
                                                                                    View all benefits
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }

                                                        @if (page.url === 'life-journeys') {
                                                            <div
                                                                class="dropdown-wrapper dropdown-wrapper--no-category-nav life-journeys">
                                                                <div
                                                                    class="nav-menu-wrapper nav-menu-wrapper--{{
                                                                        activeMenuTab.value
                                                                    }} h-auto">
                                                                    <div class="row h-100 w-100 g-2">
                                                                        @for (
                                                                            child of $any(
                                                                                page.children
                                                                                    | orderBy: [navigationOrder]
                                                                            );
                                                                            track child
                                                                        ) {
                                                                            <div
                                                                                class="nav-menu-item col-12 col-md-3 d-flex">
                                                                                <a
                                                                                    (click)="
                                                                                        navigateToPage([page, child])
                                                                                    "
                                                                                    [attr.aria-label]="
                                                                                        'Learn more about ' + child.name
                                                                                    "
                                                                                    [core-analytics]="{
                                                                                        action: child.url,
                                                                                        category: 'TOP-NAV',
                                                                                    }"
                                                                                    [ngClass]="{
                                                                                        active: setDropdownActiveLinkState(
                                                                                            child
                                                                                        ),
                                                                                    }"
                                                                                    class="nav-menu-item__link flex-column"
                                                                                    href="javascript:void(0)">
                                                                                    <span class="nav-menu-item__name">{{
                                                                                        child.name
                                                                                    }}</span>
                                                                                    <span class="nav-menu-item__desc">{{
                                                                                        child.description | limitTo: 85
                                                                                    }}</span>
                                                                                    <span class="nav-menu-item__icon">
                                                                                        <img
                                                                                            [alt]="child.name"
                                                                                            [src]="
                                                                                                validImageUrl(child)
                                                                                            " />
                                                                                    </span>
                                                                                </a>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                </div>

                                                <div
                                                    [style.--color-banner-bg]="bgNav || null"
                                                    [style.--color-nav-link]="linkColorVar || null"
                                                    [style.background-color]="bgNav || null"
                                                    class="dropdown-wrapper-mobile">
                                                    @if (searchEnabled) {
                                                        <core-client-search
                                                            (closeTopnavHamburgerNav)="isCollapsed = !isCollapsed"
                                                            class="core-search-form--mobile">
                                                        </core-client-search>
                                                    }
                                                    @if (getMobileNavPages(page, content || null); as mobilePages) {
                                                        @if (mobilePages.length > 0) {
                                                            <div
                                                                (click)="closeChildDropdown($event)"
                                                                (keydown)="closeChildDropdown($event)"
                                                                [style.--color-nav-link]="linkColorVar || null"
                                                                class="nav-menu-item-back d-flex align-items-center"
                                                                tabindex="0">
                                                                <svg
                                                                    height="50"
                                                                    viewBox="0 0 52 50"
                                                                    width="52"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <rect
                                                                        fill="#F0F1F2"
                                                                        height="50"
                                                                        rx="25"
                                                                        width="52" />
                                                                    <mask
                                                                        height="18"
                                                                        id="mask0_583_15973"
                                                                        maskUnits="userSpaceOnUse"
                                                                        style="mask-type: alpha"
                                                                        width="12"
                                                                        x="20"
                                                                        y="16">
                                                                        <rect
                                                                            fill="#D9D9D9"
                                                                            height="18"
                                                                            width="12"
                                                                            x="20"
                                                                            y="16" />
                                                                    </mask>
                                                                    <g mask="url(#mask0_583_15973)">
                                                                        <path
                                                                            d="M28 32.5L20.5 25L28 17.5L29.3313 18.8313L23.1625 25L29.3313 31.1688L28 32.5Z"
                                                                            fill="#1C1B1F" />
                                                                    </g>
                                                                </svg>
                                                                <div [innerText]="page.name" class="ps-3"></div>
                                                            </div>
                                                            <ul class="benefits-nav-list">
                                                                @for (
                                                                    navPage of $any(
                                                                        mobilePages | orderBy: [navigationOrder]
                                                                    );
                                                                    track trackByFn(i, navPage);
                                                                    let i = $index
                                                                ) {
                                                                    <li class="benefits-nav-list__item">
                                                                        <a
                                                                            (click)="navigateToPage([navPage])"
                                                                            [core-analytics]="{
                                                                                action: navPage.url,
                                                                                category: 'TOP-NAV',
                                                                            }"
                                                                            [innerText]="navPage.name"
                                                                            href="javascript:void(0)">
                                                                        </a>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        }
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </li>
                                }
                            }
                        }
                    }

                    @if (isLoggedIn && !isDesktop) {
                        <li class="nav-item">
                            <a
                                (click)="logout()"
                                [core-analytics]="{ action: 'Logout', category: 'TOP-NAV' }"
                                class="nav-link d-flex align-items-center"
                                href="javascript:void(0)">
                                {{ 'Logout' | translate }}
                                <span class="material-symbols-outlined ms-1">{{ 'Logout' | translate }}</span>
                            </a>
                        </li>
                    }

                    @if (!isDesktop && (canShowUtilitiesAbove || canShowUtilitiesBelow)) {
                        <core-top-nav-utilities
                            class="d-nav-none"
                            position="mobile"
                            (clickLink)="isCollapsed = true"></core-top-nav-utilities>
                    }

                    @if (!isCollapsed && showMobileNavFooter()) {
                        <div [style.background-color]="bgNav || null" class="fixed-mobile-nav-footer">
                            <span class="nav-link">
                                @if (contactEnabled) {
                                    <a
                                        [core-analytics]="{ action: 'Get in touch', category: 'TOP-NAV' }"
                                        class="btn btn-primary mb-0"
                                        routerLink="/contact">
                                        {{ 'Get in touch?' | translate }}
                                    </a>
                                }
                                @if (contactEnabled && customContactButtonEnabled) {
                                    <span class="ms-2"></span>
                                }
                                @if (customContactButtonEnabled) {
                                    <a
                                        [core-analytics]="{ action: customContactButtonText, category: 'TOP-NAV' }"
                                        [target]="customContactButtonTarget ? '_blank' : '_self'"
                                        class="btn mb-0"
                                        [style.background-color]="customContactButtonActionBg || null"
                                        [style.color]="customContactButtonActionText || null"
                                        [href]="customContactButtonPath"
                                        [innerHTML]="customContactButtonText | translate">
                                    </a>
                                }
                            </span>
                        </div>
                    }
                </ul>
            </div>
        </div>
    </nav>
}
